import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../../components/Hero/Hero';
import AboutPreview from '../../components/AboutPreview/AboutPreview';
import PortfolioPreview from '../../components/PortfolioPreview/PortfolioPreview';
import ServicesPreview from '../../components/ServicesPreview/ServicesPreview';
import './Home.css';

const Home: React.FC = () => {
  return (
    <main>
      <Hero />
      <PortfolioPreview />
      <AboutPreview />
      <ServicesPreview />
      
      {/* Final CTA Section */}
      <section className="home-final-cta">
        <div className="container">
          <div className="final-cta-content">
            <h2>Ready to Transform Your <span id="gold">Space</span>?</h2>
            <p>Let's collaborate to bring your architectural vision to life. Get started with a free consultation today.</p>
            
            <div className="final-cta-buttons">
              <Link to="/contact" className="primary-cta">
                <div className="btn-text">
                  <h4>Start Your Project</h4>
                </div>
                <div className="btn-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h14m-7-7 7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </Link>
              
              <Link to="/portfolio" className="secondary-cta">
                <div className="btn-text">
                  <h4>View More Projects</h4>
                </div>
              </Link>
            </div>
            
            <div className="contact-quick-info">
              <div className="quick-info-item">
                <strong>Call:</strong> <a href="https://wa.me/6281224502854?text=Halo%20BlueLake%2C%20Saya%20ingin%20tanya-tanya%20terkait%20proyek%20saya">+62 812-2450-2854</a>
              </div>
              <div className="quick-info-item">
                <strong>Email:</strong> <a href="mailto:bluelake.id@gmail.com">bluelake.id@gmail.com</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;